module.exports = __webpack_public_path__ + "resources/img/img_goldilocks2.3e63f4b75f8d6d4ee1a711ae370f6085.png";